var _path, _path2, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownwardTrendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13428 0.749993L7.00928 4.49999L9.25928 1.87499L16.875 7.875",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3843 8.25L17.0219 8.25L17.2503 8.25L17.2503 4.5",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5972_4653",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1.125,
    transform: "matrix(1 0 -6.411e-08 -1 13.5 17.25)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1.125,
    transform: "matrix(1 0 -6.411e-08 -1 13.5 17.25)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_5972_4653)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_5972_4653",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 7.5,
    rx: 1.125,
    transform: "matrix(1 0 -8.88104e-08 -1 6.75 17.25)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 7.5,
    rx: 1.125,
    transform: "matrix(1 0 -8.88104e-08 -1 6.75 17.25)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 3,
    mask: "url(#path-4-inside-2_5972_4653)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_5972_4653",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 9.75,
    rx: 1.125,
    transform: "matrix(1 0 -8.88104e-08 -1 1.90735e-06 17.25)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 9.75,
    rx: 1.125,
    transform: "matrix(1 0 -8.88104e-08 -1 1.90735e-06 17.25)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 3,
    mask: "url(#path-5-inside-3_5972_4653)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M4.13672 9.54492V10.2949H1.70215V9.54492H4.13672Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M10.9673 11.7949V12.5449H8.53272V11.7949H10.9673Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M17.7173 13.125V13.875H15.2827V13.125H17.7173Z",
    fill: "#1A1E23",
    stroke: "#1A1E23",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardTrendIcon);
export default __webpack_public_path__ + "static/media/downward-trend-icon.a85871e9c5bf0ea23318e0d5738dd3b0.svg";
export { ForwardRef as ReactComponent };